import PropTypes from 'prop-types';
import React, {useMemo} from 'react';
import {StyledInvoiceFilePreviewWithIcon} from './StyledInvoiceFilePreviewWithIcon';
import InvoiceAttachmentPreview from '../../TransactionsPage/InvoiceAttachmentPreview';
import ImagePreviewTooltip from '../../TransactionsPage/ImagePreviewTooltip';
import {DocumentApprovedIcon} from '../../../../icons';
import {fileHelpers} from '../../../../utils/helpers';

const InvoiceFilePreviewWithIcon = ({
  fileName,
  fileUrl,
  ...rest
}) => {

  const tooltipContent = useMemo(() => {
    if (!fileUrl) return null;

    const attachment = { file: fileUrl, name: fileName || fileHelpers.getFileNameFromUrl(fileUrl) };
    return <InvoiceAttachmentPreview attachment={attachment} />;
  }, [fileName, fileUrl]);

  return (
    <ImagePreviewTooltip
      overlayClassName='image-preview-tooltip-overlay single unset-tooltip-width'
      title={tooltipContent}
    >
      <StyledInvoiceFilePreviewWithIcon {...rest}>
        <DocumentApprovedIcon />
      </StyledInvoiceFilePreviewWithIcon>
    </ImagePreviewTooltip>
  );
}

InvoiceFilePreviewWithIcon.propTypes = {
  fileName: PropTypes.string,
  fileUrl: PropTypes.string,
}

export default InvoiceFilePreviewWithIcon;
